import { EventTypes } from 'redux-segment';
import * as feedAPI from '../common/api/feed';
import preserveNextStart from '../utils/preserveNextStart';

export const FETCH_PROMOBOX_SLIDES = 'FETCH_PROMOBOX_SLIDES';
export const FETCH_PROMOBOX_SLIDES_SUCCESS = 'FETCH_PROMOBOX_SLIDES_SUCCESS';
export const FETCH_PROMOBOX_SLIDES_FAILURE = 'FETCH_PROMOBOX_SLIDES_FAILURE';

export const FETCH_FEED = 'FETCH_FEED';
export const FETCH_FEED_SUCCESS = 'FETCH_FEED_SUCCESS';
export const FETCH_FEED_FAILURE = 'FETCH_FEED_FAILURE';

export const ENABLE_INFINITE_SCROLLING = 'ENABLE_INFINITE_SCROLLING';

export const startInfiniteScrolling = () => ({
  type: ENABLE_INFINITE_SCROLLING,
});

export const fetchPromoBoxSlides = () => async (dispatch) => {
  dispatch({
    type: FETCH_PROMOBOX_SLIDES,
  });

  try {
    const payload = await feedAPI.fetchPromoBoxSlides();
    dispatch({
      type: FETCH_PROMOBOX_SLIDES_SUCCESS,
      cards: payload.data.promobox.slice(7),
      slides: payload.data.promobox.slice(0, 7),
    });
  } catch (error) {
    dispatch({
      type: FETCH_PROMOBOX_SLIDES_FAILURE,
      error,
    });
  }
};

export const fetchFeed = () => async (dispatch, getState) => {
  dispatch({
    type: FETCH_FEED,
  });

  try {
    const state = getState();
    const { curated, feedLarge, feedSmall, pageCount } = state.homepage.feed;
    let articles = await feedAPI.fetchFeedArticles(
      curated.nextStart, feedLarge.nextStart, feedSmall.nextStart,
    );
    articles = preserveNextStart(
      articles,
      curated.nextStart,
      feedLarge.nextStart,
      feedSmall.nextStart,
    );
    dispatch({
      type: FETCH_FEED_SUCCESS,
      articles,
      ...(pageCount > 0 ? { meta: { // don't send segment event until inf scroll enabled
        analytics: {
          eventType: EventTypes.track,
          eventPayload: {
            event: 'Scrolled Feed',
            properties: {
              category: 'Home Page Feed',
              pageCounter: pageCount,
            },
          },
        },
      } } : null),
    });
  } catch (error) {
    dispatch({
      type: FETCH_FEED_FAILURE,
      error,
    });
  }
};
